import { EventBus } from '@/event-bus'
import * as joint from '@clientio/rappid'
import { Artifact } from '@/models'
import { Events } from '@/models/events.model'
import ExpandButton from './../expand-button'
import { useHelpers } from './helpers'
import { injectTyped } from '@/inject'
import { ServiceKeys } from '@/services/symbols'

export function useRegisterArtifactContainerMenu() {
  const rappidContext = injectTyped(ServiceKeys.rappidContext)

  const { getArtifactFromElementView } = useHelpers()

  function openArtifactContainerMenu(
    currentArtifact: Artifact,
    artifactCellDropdown: ExpandButton,
    currentCell: joint.dia.ElementView,
  ) {
    const inputData: Events['openContainerMenuArtifact'] = {
      currentArtifact,
      artifactCellDropdown,
      currentCell,
    }

    EventBus.emit('openContainerMenuArtifact', inputData)
  }

  function registerArtifactContainerMenu() {
    const boundaryTool = new joint.elementTools.Boundary()

    const expandButton = new ExpandButton((cellView: joint.dia.ElementView) => {
      const currentCellArtifact = getArtifactFromElementView(cellView)

      if (currentCellArtifact !== undefined) {
        openArtifactContainerMenu(currentCellArtifact, expandButton, cellView)
      }
    })

    const toolsView = new joint.dia.ToolsView({
      tools: [boundaryTool, expandButton],
    })

    rappidContext.paper.on('element:mouseenter', (elementView: joint.dia.ElementView) => {
      if (getArtifactFromElementView(elementView) !== undefined) {
        elementView.addTools(toolsView)
        elementView.showTools()
      }
    })
    rappidContext.paper.on('element:mouseleave', (elementView: joint.dia.ElementView) => {
      if (getArtifactFromElementView(elementView) !== undefined) {
        elementView.hideTools()
        elementView.removeTools()
      }
    })
  }

  return { registerArtifactContainerMenu }
}
